// AUTO-GENERATED from weborder.json (OpenAPI). Do not edit by hand.
// Domain: questions
// Regenerate via scripts/gen-dtos.py

/**
 * Active rule group (rule_groups_master) for a speciality: group name plus
 * nested active rules, options, and UI-collected outputs.
 */
export class SpecialityQuestionGroupDto {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {number} */
    this.id = raw.id ?? 0; // Group id.
    /** @type {string} */
    this.groupName = raw.groupName ?? ""; // Group display name from question_group.
    /** @type {number} */
    this.displayOrder = raw.displayOrder ?? 0; // Display order within the speciality (1-based).
    /** @type {SpecialityQuestionRuleDto[]} */
    this.questions = Array.isArray(raw.questions) ? raw.questions.map((x) => new SpecialityQuestionRuleDto(x)) : [];
  }
}

/**
 * Active rule (rules_master) under a group.
 */
export class SpecialityQuestionRuleDto {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {number} */
    this.id = raw.id ?? 0; // Rule master id.
    /** @type {string} */
    this.questionText = raw.questionText ?? ""; // Question text.
    /** @type {string} */
    this.questionDescription = raw.questionDescription ?? ""; // Optional short helper text shown with the question (max 255 characters).
    /** @type {number} */
    this.displayOrder = raw.displayOrder ?? 0; // Display order within the group (1-based).
    /** @type {string} */
    this.questionType = raw.questionType ?? ""; // Input control type (matches QuestionsInputType).
    /** @type {boolean} */
    this.isRequired = raw.isRequired ?? false; // Whether an answer is required.
    /** @type {SpecialityQuestionOptionDto[]} */
    this.options = Array.isArray(raw.options) ? raw.options.map((x) => new SpecialityQuestionOptionDto(x)) : [];
  }
}

/**
 * Active choice for a rule (rule_option).
 */
export class SpecialityQuestionOptionDto {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {number} */
    this.id = raw.id ?? 0; // Option id.
    /** @type {string} */
    this.optionLabel = raw.optionLabel ?? ""; // Display label.
    /** @type {string} */
    this.optionValue = raw.optionValue ?? ""; // Stored value when selected.
    /** @type {string} */
    this.optionDescription = raw.optionDescription ?? ""; // Optional helper text shown under the option (max 255 chars).
    /** @type {number} */
    this.displayOrder = raw.displayOrder ?? 0; // Display order among options.
    /** @type {boolean} */
    this.isDefault = raw.isDefault ?? false; // Whether this option is the default.
    /** @type {SpecialityQuestionOutputDto[]} */
    this.impacts = Array.isArray(raw.impacts) ? raw.impacts.map((x) => new SpecialityQuestionOutputDto(x)) : [];
    /** @type {string[]} */
    this.hideQuestions = Array.isArray(raw.hideQuestions) ? raw.hideQuestions : []; // Question ids/keys hidden when this option is selected.
    /** @type {string[]} */
    this.showQuestions = Array.isArray(raw.showQuestions) ? raw.showQuestions : []; // Question ids/keys shown when this option is selected.
  }
}

/**
 * Rule output row collected from the UI for this option (isCollectFromUi =
 * true).
 */
export class SpecialityQuestionOutputDto {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {number} */
    this.id = raw.id ?? 0; // Rule output master id.
    /** @type {string} */
    this.impactType = raw.impactType ?? ""; // Impact type (matches QuestionAnswerImpact).
    /** @type {boolean} */
    this.isRequired = raw.isRequired ?? false; // When true, a follow-up answer is required when this option is selected.
  }
}

// QuestionGroupDto - not in spec

// QuestionDto - not in spec

// QuestionOptionDto - not in spec

// QuestionOptionImpactDto - not in spec

export class GroupQuestionsDto {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {number} */
    this.id = raw.id ?? 0;
    /** @type {string} */
    this.groupName = raw.groupName ?? "";
    /** @type {number} */
    this.attemptQuestion = raw.attemptQuestion ?? 0;
    /** @type {number} */
    this.totalQuestion = raw.totalQuestion ?? 0;
  }
}

export class SubmissionQuestionGroupResponseDto {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {number} */
    this.id = raw.id ?? 0;
    /** @type {string} */
    this.groupName = raw.groupName ?? "";
    /** @type {number} */
    this.displayOrder = raw.displayOrder ?? 0;
    /** @type {SubmissionQuestionResponseDto[]} */
    this.questions = Array.isArray(raw.questions) ? raw.questions.map((x) => new SubmissionQuestionResponseDto(x)) : [];
  }
}

export class SubmissionQuestionResponseDto {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {number} */
    this.id = raw.id ?? 0;
    /** @type {number} */
    this.questionId = raw.questionId ?? 0;
    /** @type {string} */
    this.questionText = raw.questionText ?? "";
    /** @type {string} */
    this.questionDescription = raw.questionDescription ?? "";
    /** @type {boolean} */
    this.isRequired = raw.isRequired ?? false;
    /** @type {string} */
    this.questionType = raw.questionType ?? "";
    /** @type {number} */
    this.displayOrder = raw.displayOrder ?? 0;
    /** @type {boolean} */
    this.isHidden = raw.isHidden ?? false;
    /** @type {SubmissionQuestionOptionResponseDto[]} */
    this.options = Array.isArray(raw.options) ? raw.options.map((x) => new SubmissionQuestionOptionResponseDto(x)) : [];
  }
}

export class SubmissionQuestionOptionResponseDto {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {number} */
    this.id = raw.id ?? 0;
    /** @type {string} */
    this.optionLabel = raw.optionLabel ?? "";
    /** @type {string} */
    this.optionValue = raw.optionValue ?? "";
    /** @type {string} */
    this.optionDescription = raw.optionDescription ?? "";
    /** @type {string} */
    this.answerValue = raw.answerValue ?? "";
    /** @type {number} */
    this.displayOrder = raw.displayOrder ?? 0;
    /** @type {SubmissionQuestionImpactResponseDto[]} */
    this.impacts = Array.isArray(raw.impacts) ? raw.impacts.map((x) => new SubmissionQuestionImpactResponseDto(x)) : [];
    /** @type {string[]} */
    this.hideQuestions = Array.isArray(raw.hideQuestions) ? raw.hideQuestions : [];
    /** @type {string[]} */
    this.showQuestions = Array.isArray(raw.showQuestions) ? raw.showQuestions : [];
    /** @type {boolean} */
    this.isDefault = raw.isDefault ?? false;
  }
}

export class SubmissionQuestionImpactResponseDto {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {number} */
    this.id = raw.id ?? 0;
    /** @type {string} */
    this.impactType = raw.impactType ?? ""; // QuestionAnswerImpact enum name from the submission snapshot.
    /** @type {boolean} */
    this.isRequired = raw.isRequired ?? false;
    /** @type {string} */
    this.impactInputType = raw.impactInputType ?? "";
    /** @type {string} */
    this.impactOutput = raw.impactOutput ?? "";
    /** @type {string} */
    this.impactAction = raw.impactAction ?? "";
    /** @type {string} */
    this.answerValue = raw.answerValue ?? "";
  }
}

/**
 * Body for POST /api/weborder/v1/questions/save. Requires an authenticated
 * insured JWT (not available anonymously). Updates `selected_value` on
 * `submission_question_option` and `submission_question_impact` rows only
 * (nested under the insured's submission). Answers are grouped by
 * `submission_question_group`. Send one or more groups per call; for each
 * group, every `isRequired` question in that group must appear under that
 * group and be answered — unless the question is currently hidden by a
 * `QUESTIONS_VISIBILITY` impact, in which case it is not required-validated
 * and its stored answer is cleared to `null`. Groups must be completed in
 * `displayOrder`: a group can be saved only once every lower-order group has
 * all its visible questions answered (groups sent in the same request are
 * exempt).
 */
export class SubmissionQuestionAnswersSaveRequest {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {number} */
    this.submissionId = raw.submissionId ?? 0; // Target submission id (> 0); must belong to the authenticated insured.
    /** @type {SubmissionQuestionGroupAnswersItemDto[]} */
    this.groups = Array.isArray(raw.groups) ? raw.groups.map((x) => new SubmissionQuestionGroupAnswersItemDto(x)) : []; // One entry per submission question group being updated (subset of the submission). Nested `...
  }
}

/**
 * One submission question group and the question/option answers to persist
 * for that group.
 */
export class SubmissionQuestionGroupAnswersItemDto {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {number} */
    this.submissionQuestionGroupId = raw.submissionQuestionGroupId ?? 0; // `submission_question_group.id` for this submission (> 0).
    /** @type {SubmissionQuestionAnswerItemDto[]} */
    this.questions = Array.isArray(raw.questions) ? raw.questions.map((x) => new SubmissionQuestionAnswerItemDto(x)) : []; // One entry per submission_question in this group (every isRequired row must be included).
  }
}

/**
 * One submission question and its option/impact answer payload.
 */
export class SubmissionQuestionAnswerItemDto {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {number} */
    this.submissionQuestionId = raw.submissionQuestionId ?? 0; // `submission_question.id` (> 0)
    /** @type {SubmissionQuestionOptionAnswerDto[]} */
    this.options = Array.isArray(raw.options) ? raw.options.map((x) => new SubmissionQuestionOptionAnswerDto(x)) : []; // Options to persist for this question. Empty list clears all option and impact `selected_va...
  }
}

/**
 * Option row id, chosen value, and nested impact answers.
 */
export class SubmissionQuestionOptionAnswerDto {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {number} */
    this.submissionQuestionOptionId = raw.submissionQuestionOptionId ?? 0; // `submission_question_option.id` (> 0)
    /** @type {string} */
    this.answerValue = raw.answerValue ?? ""; // Answer stored as `submission_question_option.selected_value` (max 255). May be blank (`""`...
    /** @type {SubmissionQuestionImpactAnswerDto[]} */
    this.impacts = Array.isArray(raw.impacts) ? raw.impacts.map((x) => new SubmissionQuestionImpactAnswerDto(x)) : []; // Impact follow-ups for this option (collect-from-UI rows only).
  }
}

/**
 * Impact row id and captured answer
 * (`submission_question_impact.answer_value`).
 */
export class SubmissionQuestionImpactAnswerDto {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {number} */
    this.submissionQuestionImpactId = raw.submissionQuestionImpactId ?? 0; // `submission_question_impact.id` (> 0)
    /** @type {string} */
    this.answerValue = raw.answerValue ?? ""; // Answer stored as `answer_value` (max 255). Null or blank clears the value.
  }
}
